import _ from 'lodash';
import axios from 'axios';
import config from 'client/shared/config';

let ax;
export default function getAx () {
	if (ax) {

		return ax;
	}

	const axConfig = {
		withCredentials: true,
		headers: {
			'Content-Type': 'application/json',
			'Accept': 'application/json'
		}
	};

	ax = axios.create(axConfig);

	ax.interceptors.response.use(null, (error) => {
		if (error.response && error.response.status === 401) {

			// Defer to next tick so the rejected response finishes unwinding
			// and any in-flight HTTP/2 streams on this connection settle.
			// Racing the navigation onto a half-aborted H2 stream is what
			// produced ERR_CONNECTION_CLOSED on the post-logout redirect
			// (cross-subdomain coalesced connection got reused while the
			// 401 response stream hadn't finished closing).
			setTimeout(() => {
				window.location.replace(config.loginPageURL);
			}, 0);
		} else {

			console.log('[API Store.ax ERROR]', error);
		}

		return Promise.reject(error);
	});

	return ax;
}
